// Helper function to get environment variable with runtime fallback
const getEnvVar = (key) => {
  // First check runtime config (from window._env_)
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  // Fallback to build-time environment variable
  return process.env[key];
};

export const APPCONFIG = {

    SITE: {
        WEBAPP: getEnvVar('REACT_APP_URL_WEBAPP'),
        WEBAPI: getEnvVar('REACT_APP_URL_WEBAPI'),
        WEBAPI_SEGURIDAD: getEnvVar('REACT_APP_URL_WEBAPI_SEGURIDAD'),
        WEBAPI_ADMINISTRACION: getEnvVar('REACT_APP_URL_WEBAPI_ADMINISTRACION'),
        WEBAPP_PRINCIPAL: getEnvVar('REACT_APP_URL_WEBAPP_PRINCIPAL'),
    },
    GENERAL: {
        ENVIRONMENT: getEnvVar('REACT_APP_ENVIRONMENT'),
        REDUX_KEY: 'REDUX_KEY',
        REDUX_TIMEOUT_DEFAULT: 300, //seg
        PROCESS_TIME_INTERVAL: 10, //seg
        TITLE: 'Auditoría',
    },
    SECRETS: {
        RSA_PUBLIC_KEY: getEnvVar('REACT_APP_RSA_PUBLIC_KEY'),
    },
    PASSWORD_RULES: {
        MIN_CHARACTERS: 6,
        MIN_UPPERCASE: 1,
        MIN_LOWERCASE: 1,
        MIN_NUMBERS: 1,
        MIN_SYMBOLS: 1,
    },
}
